var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"flag-quiz-game"}},[_c('router-view'),_c('a',{staticClass:"copy-right",attrs:{"href":"https://github.com/wentingliuu/flag-quiz-game","target":"_blank"}},[_vm._v("©2022 WENTING LIU")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }